        if(document.querySelector('.discontinuation-information')) {
            function populateDropdowns() {
                let dnNoticeSet = new Set();
                let ltbDateSet = new Set();
                let ltdDateSet = new Set();
                let rows = document.getElementById('discontinuation-table').getElementsByTagName('tbody')[0].rows;

                Array.from(rows).forEach(function (row) {
                    dnNoticeSet.add(row.cells[3].innerText);
                    ltbDateSet.add(row.cells[5].innerText);
                    ltdDateSet.add(row.cells[6].innerText);
                });

                let dnNoticeArray = Array.from(dnNoticeSet).sort().reverse();
                let ltbDateArray = Array.from(ltbDateSet).sort(function (a, b) {
                    return new Date(b) - new Date(a);
                });
                let ltdDateArray = Array.from(ltdDateSet).sort(function (a, b) {
                    return new Date(b) - new Date(a);
                });

                populateDropdown('dn-notice-operator', dnNoticeArray);
                populateDropdown('ltb-date-operator', ltbDateArray);
                populateDropdown('ltd-date-operator', ltdDateArray);
            }

            function populateDropdown(elementId, valuesArray) {
                let dropdown = document.getElementById(elementId);
                dropdown.options.length = 1;
                valuesArray.forEach(function (value) {
                    let option = document.createElement('option');
                    option.value = value;
                    option.text = value;
                    dropdown.appendChild(option);
                });
            }

            function filterTable() {
                let searchText = normalizeInput(document.getElementById('search-text').value, true);
                let search4G = normalizeInput(document.getElementById('search-opn').value, true);
                let search5G = normalizeInput(document.getElementById('search-12nc').value, true);
                let dnNotice = document.getElementById('dn-notice-operator').value;
                let ltbDate = document.getElementById('ltb-date-operator').value;
                let ltdDate = document.getElementById('ltd-date-operator').value;
                let rows = document.getElementById('discontinuation-table').getElementsByTagName('tbody')[0].rows;

                Array.from(rows).forEach(function (row) {
                    let typeNumber = normalizeInput(row.cells[0].innerText, true);
                    let bands4G = normalizeInput(row.cells[1].innerText, true);
                    let bands5G = normalizeInput(row.cells[2].innerText, true);
                    let rowDnNotice = row.cells[3].innerText;
                    let rowLtbDate = row.cells[5].innerText;
                    let rowLtdDate = row.cells[6].innerText;

                    let filterByTypeNumber = !searchText || typeNumber.includes(searchText);
                    let filterBy5G = !search5G || bands5G.includes(search5G);
                    let filterBy4G = !search4G || bands4G.includes(search4G);
                    let filterByDnNotice = !dnNotice || rowDnNotice === dnNotice;
                    let filterByLtbDate = !ltbDate || rowLtbDate === ltbDate;
                    let filterByLtdDate = !ltdDate || rowLtdDate === ltdDate;

                    if (filterByTypeNumber && filterBy5G && filterBy4G && filterByDnNotice && filterByLtbDate && filterByLtdDate) {
                        row.style.display = '';
                    } else {
                        row.style.display = 'none';
                    }
                });

                updateDropdowns();
            }

            function resetSearch() {
                let rows = document.getElementById('discontinuation-table').getElementsByTagName('tbody')[0].rows;
                Array.from(rows).forEach(function (row) {
                    row.style.display = '';
                });
                document.getElementById('search-text').value = '';
                document.getElementById('search-12nc').value = '';
                document.getElementById('search-opn').value = '';

                document.getElementById('dn-notice-operator').value = '';
                document.getElementById('ltb-date-operator').value = '';
                document.getElementById('ltd-date-operator').value = '';

                populateDropdowns();
            }

            function updateDropdowns() {
                let dnNoticeSet = new Set();
                let ltbDateSet = new Set();
                let ltdDateSet = new Set();
                let rows = document.getElementById('discontinuation-table').getElementsByTagName('tbody')[0].rows;

                Array.from(rows).forEach(function (row) {
                    if (row.style.display !== 'none') {
                        dnNoticeSet.add(row.cells[3].innerText);
                        ltbDateSet.add(row.cells[5].innerText);
                        ltdDateSet.add(row.cells[6].innerText);
                    }
                });

                let dnNoticeArray = Array.from(dnNoticeSet).sort().reverse();
                let ltbDateArray = Array.from(ltbDateSet).sort(function (a, b) {
                    return new Date(b) - new Date(a);
                });
                let ltdDateArray = Array.from(ltdDateSet).sort(function (a, b) {
                    return new Date(b) - new Date(a);
                });

                let selectedDnNotice = document.getElementById('dn-notice-operator').value;
                let selectedLtbDate = document.getElementById('ltb-date-operator').value;
                let selectedLtdDate = document.getElementById('ltd-date-operator').value;

                populateDropdown('dn-notice-operator', dnNoticeArray);
                populateDropdown('ltb-date-operator', ltbDateArray);
                populateDropdown('ltd-date-operator', ltdDateArray);

                document.getElementById('dn-notice-operator').value = selectedDnNotice;
                document.getElementById('ltb-date-operator').value = selectedLtbDate;
                document.getElementById('ltd-date-operator').value = selectedLtdDate;
            }

            document.addEventListener('DOMContentLoaded', function () {
                document.getElementById('search-text').addEventListener('keyup', filterTable);
                document.getElementById('search-12nc').addEventListener('keyup', filterTable);
                document.getElementById('search-opn').addEventListener('keyup', filterTable);
                document.getElementById('dn-notice-operator').addEventListener('change', filterTable);
                document.getElementById('ltb-date-operator').addEventListener('change', filterTable);
                document.getElementById('ltd-date-operator').addEventListener('change', filterTable);
                document.querySelector('.packages-reset').addEventListener('click', resetSearch);
            });

            window.onload = populateDropdowns;
        }